import React from 'react';
import { useDispatch } from 'react-redux';
import useMediaQuery from '@/hooks/useMediaQuery';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import Icon from '@gcloud-npm/next12.components.icon-n';
import Button from '@gcloud-npm/next12.components.button-m';
import VerConvocatorias from '@/modals/VerConvocatorias';
import styled from 'styled-components';
import EnviarDocumentos from '@/modals/EnviarDocumentos';
import EnviarDocumentosIndustria from '@/modals/EnviarDocumentosIndustria';

export const COMPONENT_NAME = 'contact-steps';

const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0rem;
  margin-right: auto;
  margin-left: auto;
  @media screen and (max-width: 768px) {
    span {
      font-size: 0.875rem !important;
    }
  }
  .buttons--wrapper {
    width: 100%;
    margin: 0rem 0.5rem;
  }
  ${(props) =>
    props.colorButton1 ? `.button1 span { color: ${props.colorButton1} }` : ''}
  ${(props) =>
    props.colorButton2 ? `.button2 span { color: ${props.colorButton2} }` : ''}
    @media screen and (min-width: 769px) {
    margin-top: 2rem;
    width: 24.0625rem;
  }
`;

const HorizontalSteps = (props) => {
  const { components, bgColor } = props;
  const title = props['TextInfo-1'];
  const button1 = props['Button-1'];
  const button2 = props['Button-2'];

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const isMobile = useMediaQuery('(max-width: 768px)');

  const dispatch = useDispatch();

  const handleVerConvocatorias = () => {
    const MODAL_PROPS = {
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: 'verconvocatorias',
        type: 'MODAL',
        elementProps: {
          taggingInfo,
        },
        Element2Show: VerConvocatorias,
        modalProps: MODAL_PROPS,
      })
    );
  };

  const handleEnviarDocumentos = (valley) => {
    const MODAL_PROPS = {
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: 'enviarDocumentos',
        type: 'MODAL',
        elementProps: {
          taggingInfo,
        },
        Element2Show: valley ? EnviarDocumentos : EnviarDocumentosIndustria,
        modalProps: MODAL_PROPS,
      })
    );
  };

  return (
    <>
      <section
        className={`HorizontalSteps background-color--${bgColor || 'blue'}`}
      >
        <div className="container">
          {title && (
            <div className="title">
              <TextInfo
                {...title}
                size={isMobile ? title.size : title.sizeDesktop}
              />
            </div>
          )}
          <div className="steps">
            {components.map((component, index) => (
              <div className="card">
                <div className="circleBg">
                  <div className={`number number--${bgColor}`}>{index + 1}</div>
                </div>
                <div className="textWrapper">
                  <div className="text">
                    <TextInfo {...component['TextInfo-1']} />
                    {(component.href || component.displayModal) && (
                      <div className="icon--wrapper">
                        <Icon
                          id="CheuronRight"
                          color="white"
                          size={16}
                          segment="emp"
                        />
                      </div>
                    )}
                  </div>
                </div>
                {(component.href || component.displayModal) && (
                  <CustomLink
                    isBlockElement
                    href={component.href}
                    target={component.hrefTarget}
                    onClick={
                      component.displayModal
                        ? () => {
                            handleEnviarDocumentos(component.modalValley);
                          }
                        : ''
                    }
                    taggingInfo={{
                      ...taggingInfo,
                      componentContent: `step -${index + 1}`,
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          {(button1 || button2) && (
            <StyledButtons
              colorButton1={button1.color}
              colorButton2={button2.color}
            >
              {button1 && (
                <div className="buttons--wrapper button1">
                  <Button
                    {...button1}
                    onClick={button1.modal ? handleVerConvocatorias : ''}
                    taggingInfo={{
                      ...taggingInfo,
                      componentContent: button1.label,
                    }}
                  />
                </div>
              )}
              {button2 && (
                <div className="buttons--wrapper button2">
                  <Button
                    {...button2}
                    taggingInfo={{
                      ...taggingInfo,
                      componentContent: 'interes',
                    }}
                  />
                </div>
              )}
            </StyledButtons>
          )}
        </div>
      </section>
      <style jsx>
        {`
          .background-color {
            &--white {
              background-color: var(--white);
            }
            &--blue {
              background-color: var(--color-emp--blue);
            }
            &--pink {
              background-color: #e44d8d;
            }
            &--turquoise {
              background-color: var(--color-emp--turquoise);
            }
          }
          .HorizontalSteps {
            padding-top: 0.5rem;
            padding-bottom: 2.5rem;
            .title {
              padding: 1rem 0;
            }
            .steps {
              display: flex;
              flex-direction: column;
              padding: 1rem 0;
              .noBalls {
                padding: 0rem 1.25rem;
              }
              .card {
                display: flex;
                flex-direction: row;
                margin-bottom: 2rem;
                flex: 1 1 0px;
                align-items: center;
                position: relative;
                .circleBg {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: var(--color-emp--grey0);
                  border-radius: 50%;
                  min-width: 4rem;
                  max-width: 4rem;
                  min-height: 4rem;
                  max-height: 4rem;
                  margin: 0.5rem 1rem 0;
                  .number {
                    font-size: 1.5rem;
                    &--white {
                      color: var(--white);
                    }
                    &--blue {
                      color: var(--color-emp--blue);
                    }
                    &--pink {
                      color: #e44d8d;
                    }
                    &--turquoise {
                      color: var(--color-emp--turquoise);
                    }
                  }
                }
                .textWrapper {
                  .title {
                    padding: 0.5rem 0;
                  }
                  .icon--wrapper {
                    display: inline-block;
                    margin-left: 0.5rem;
                  }
                }
              }
            }
          }

          @media screen and (min-width: 1024px) {
            .HorizontalSteps {
              .steps {
                flex-direction: row;
                .card {
                  margin-bottom: 0;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default HorizontalSteps;
